export const MIN_GROUPS = 1;
export const MAX_GROUPS = 16;
export const DEFAULT_GROUPS_COUNT = 4;

export const MIN_SEASON_YEAR = 1900;
export const MAX_SEASON_YEAR = 2100;

/** Limite de times participantes selecionáveis numa temporada. */
export const MAX_SEASON_TEAMS = 200;

/** Tamanho da página na busca de clubes (Step 3). */
export const TEAMS_SEARCH_PAGE_SIZE = 20;

/**
 * Sugestões iniciais de fases de mata-mata para uma temporada KNOCKOUT.
 * Cada item é uma chave de i18n em `season_step2.default_stage_names`.
 */
export const DEFAULT_KNOCKOUT_STAGE_KEYS = [
  'round_of_16',
  'quarterfinals',
  'semifinals',
  'final',
] as const;

/**
 * Sugestões iniciais de fases eliminatórias para uma temporada HYBRID
 * (a fase de grupos já é gerada a partir de `groups_count`).
 */
export const DEFAULT_HYBRID_KNOCKOUT_STAGE_KEYS = [
  'semifinals',
  'final',
] as const;

/**
 * Colunas configuráveis da tabela de classificação (visibilidade no app do
 * torcedor). `position` e o nome do time ficam sempre visíveis e não entram
 * aqui. A ordem define a ordem de exibição na UI do checklist.
 * Cada chave tem um label em i18n `season_step1.standings_columns.<key>`.
 */
export const STANDINGS_COLUMN_KEYS = [
  'points',
  'played',
  'wins',
  'draws',
  'losses',
  'goals_for',
  'goals_against',
  'goal_diff',
] as const;

export type StandingsColumnKey = (typeof STANDINGS_COLUMN_KEYS)[number];

/** Default: todas as colunas visíveis. */
export const DEFAULT_STANDINGS_COLUMNS: Record<StandingsColumnKey, boolean> =
  STANDINGS_COLUMN_KEYS.reduce(
    (acc, key) => ({ ...acc, [key]: true }),
    {} as Record<StandingsColumnKey, boolean>,
  );
